<template>
  <pt-detection-package-new class="pt-detection-package-new__withData"></pt-detection-package-new>
</template>

<script>
import PtDetectionPackageNew from './index'
export default {
  name: 'pt-detection-package-new__withData',
  components: {
    'pt-detection-package-new': PtDetectionPackageNew
  }
}
</script>
